"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RocheListItemText = void 0;

var _react = _interopRequireDefault(require("react"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _core = require("../core");

var _utils = require("../utils");

var _list = require("./list.context");

var _listItemText = require("./list-item-text.styles");

var _excluded = ["classes", "primaryTypographyProps", "secondaryTypographyProps"],
    _excluded2 = ["typographyRoot"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var RocheListItemText = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _useListContext;

  var classes = _ref.classes,
      primaryTypographyProps = _ref.primaryTypographyProps,
      secondaryTypographyProps = _ref.secondaryTypographyProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _mergeClasses = (0, _utils.mergeClasses)((0, _listItemText.useStyles)(), classes),
      typographyRoot = _mergeClasses.typographyRoot,
      innerClasses = _objectWithoutProperties(_mergeClasses, _excluded2); // Determine size based on context:


  var context = (_useListContext = (0, _list.useListContext)()) !== null && _useListContext !== void 0 ? _useListContext : {};
  var _context$size = context.size,
      size = _context$size === void 0 ? 'medium' : _context$size;
  return /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], _extends({
    classes: innerClasses,
    primaryTypographyProps: _objectSpread({
      variant: size === 'extraSmall' ? 'caption' : size === 'small' ? 'body2' : 'body1',
      className: typographyRoot
    }, primaryTypographyProps),
    secondaryTypographyProps: _objectSpread({
      variant: size === 'extraSmall' ? 'caption' : size === 'small' ? 'caption' : 'body2'
    }, secondaryTypographyProps),
    ref: ref
  }, rest));
});

exports.RocheListItemText = RocheListItemText;
RocheListItemText.displayName = (0, _core.rochePrefix)('ListItemText');
RocheListItemText.defaultProps = {};
var _default = RocheListItemText;
exports["default"] = _default;